<template>
  <q-card>
    <q-toolbar>
      <q-toolbar-title class="text-center">
        Login
      </q-toolbar-title>
    </q-toolbar>
    <q-separator />
    <form v-if="!response || !response.nextAction" @submit.prevent="login">
      <q-card-section>
        <q-input
          label="Email"
          type="email"
          name="email"
          v-model="command.email"
          outlined/>
        <password-input
          class="q-mt-md"
          label="Password"
          v-model="command.password"
          outlined
        />
        <div class="q-mt-sm">
          <router-link to="/recover-password">Forgot password</router-link>
        </div>
        <q-toggle class="q-mt-md" v-model="command.remember">
          Stay logged in
        </q-toggle>
      </q-card-section>
      <q-card-actions>
        <async-btn
          type="submit"
          :task="task"
          label="Login"
          color="primary"
          class="full-width"/>
      </q-card-actions>
    </form>
    <mfa-login
      v-else-if="response && response.nextAction"
      :command="command"
      :user-id="response.user.id"
      @success="onLogin"
    />
  </q-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { RouteLocationNormalizedLoaded as Route } from 'vue-router';
import isGuestRoute from '@/auth/isGuestRoute';
import AsyncBtn from '@/components/AsyncBtn.vue';
import PasswordInput from '@/components/form/PasswordInput.vue';
import { login, LoginCommand, LoginResponse } from './auth';
import MFALogin from './MFALogin.vue';

interface Data {
  command: LoginCommand,
  task: Promise<LoginResponse>|null,
  redirect: string,
  response: LoginResponse|null,
}

export default defineComponent({
  components: {
    AsyncBtn,
    PasswordInput,
    'mfa-login': MFALogin,
  },
  meta: {
    title: 'Login',
  },
  data(): Data {
    return {
      command: {
        email: '',
        password: '',
        remember: false,
      },
      task: null,
      redirect: '/',
      response: null,
    };
  },
  methods: {
    login() {
      this.task = login(this.command);
      this.task.then((response) => {
        this.response = response;
        if (!response.nextAction) {
          this.onLogin();
        }
      });
    },
    onLogin() {
      this.$router.push(this.redirect);
    },
  },
  beforeRouteEnter(current: Route, prev: Route, next: any): void {
    next((vm: any) => {
      if (current.query.redirect && !isGuestRoute(prev.path)) {
        vm.redirect = prev.fullPath;
      }
      if (current.query.target) {
        vm.redirect = current.query.target;
      }
    });
  },
});
</script>
